import React from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { tViews } from "../../../utils/table";

const [HbrViewSwitcher, HbrRadioButton] = reactWrapper([
  "hbr-view-switcher",
  "hbr-radio-button",
]);
const availabilityStatus = [
  {
    key: "all",
    get value() {
      return tViews("allSiteAllLabel");
    },
  },
  {
    key: "low",
    get value() {
      return tViews("allSiteLowLabel");
    },
  },
  {
    key: "fair",
    get value() {
      return tViews("allSiteFairLabel");
    },
  },
  {
    key: "high",
    get value() {
      return tViews("allSiteHighLabel");
    },
  },
  {
    key: "unknown",
    get value() {
      return tViews("allSiteUnknownLabel");
    },
  },
];

const SiteFilter = ({ value, onChange, loader = false }) => (
  <HbrViewSwitcher
    value={value}
    onHbr-change={onChange}
    noFieldset={true}
    role="group"
    aria-label={tViews("a11yLabels.siteListGroupLabel")}
  >
    {availabilityStatus.map(({ key, value }) => (
      <HbrRadioButton
        key={key}
        value={key}
        disabled={loader}
        data-testid={`availablity-filter-${key}`}
      >
        {value}
      </HbrRadioButton>
    ))}
  </HbrViewSwitcher>
);

SiteFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  loader: PropTypes.bool,
};

export default SiteFilter;
